var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcConnect = function SvgIcConnect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic_connect_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 23C5.93 23 1 18.07 1 12S5.93 1 12 1s11 4.93 11 11-4.93 11-11 11Z",
    fill: "#60C67F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.999 16.44a4.44 4.44 0 1 0 0-8.88 4.44 4.44 0 0 0 0 8.88Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ic_connect_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIcConnect;